import script from "./TenantApiKeys.vue?vue&type=script&lang=ts&setup=true"
export * from "./TenantApiKeys.vue?vue&type=script&lang=ts&setup=true"

import "./TenantApiKeys.vue?vue&type=style&index=0&id=7c867ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c867ac8"]])

export default __exports__